import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * ThemeSelector - Dropdown to select from available themes
 * Displays in the header/navbar
 */
export function ThemeSelector() {
  const { theme, setTheme, themes } = useTheme();

  const currentTheme = themes.find(t => t.id === theme);

  return (
    <details className="dropdown dropdown-end">
      <summary className="btn btn-ghost btn-sm gap-2">
        {/* Palette Icon */}
        <svg
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
          />
        </svg>
        <span className="hidden sm:inline">{currentTheme?.icon}</span>
        {/* Chevron */}
        <svg
          className="w-3 h-3 opacity-60"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </summary>

      <ul className="dropdown-content menu bg-base-200 rounded-box z-[100] w-56 p-2 shadow-xl mt-2 max-h-80 overflow-y-auto overflow-x-hidden flex-nowrap">
        <li className="menu-title">
          <span>Select Theme</span>
        </li>
        {themes.map((t) => (
          <li key={t.id}>
            <button
              className={`flex items-center gap-3 ${theme === t.id ? 'active' : ''}`}
              onClick={() => {
                setTheme(t.id);
                // Close dropdown
                document.activeElement?.blur();
              }}
            >
              <span className="text-lg">{t.icon}</span>
              <span className="flex-1">{t.name}</span>
              {t.type === 'dark' && (
                <span className="badge badge-sm badge-ghost">Dark</span>
              )}
              {theme === t.id && (
                <svg
                  className="w-4 h-4 text-success"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </button>
          </li>
        ))}
      </ul>
    </details>
  );
}

export default ThemeSelector;
